import * as React from 'react'
import { useTranslation } from 'react-i18next'

import { useColorMode, useColorModeValue } from '@/components/ui/color-mode'
import { Switch, SwitchProps } from '@/components/ui/switch'
import { useTracking } from '@/hooks/useTracking'

export const ColorModeSwitcherButton: React.FC<SwitchProps> = (props) => {
  const { toggleColorMode } = useColorMode()
  const isChecked = useColorModeValue(false, true)
  const { t } = useTranslation()
  const { captureEvent } = useTracking()

  const handleToggle = () => {
    const newMode = isChecked ? 'light' : 'dark'
    captureEvent('theme_mode_changed', {
      previous_mode: isChecked ? 'dark' : 'light',
      new_mode: newMode,
    })
    toggleColorMode()
  }

  return (
    <Switch
      title={t(`switch.mode.${isChecked ? 'dark' : 'light'}`)}
      onChange={handleToggle}
      checked={isChecked}
      colorPalette={'brand'}
      ml="2"
      {...props}
    >
      {t(`switch.mode.${isChecked ? 'dark' : 'light'}`)}
    </Switch>
  )
}
